import { FederatedMultiSearchParams, Meilisearch, MultiSearchParams, MultiSearchResponse, RecordAny } from 'meilisearch';
import { from, map, switchMap, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthServices } from './auth.services';
import { inject } from '@angular/core';
import { UserRoles } from '../enums/roles.enum';

export class MeilisearchService {
  private readonly client = new Meilisearch({ host: environment.meilisearch, apiKey: environment.meilisearchKey });
  usersService = inject(AuthServices);

  search(query: string, selectedIndexes: string[]) {
    return this.usersService.user().pipe(
      map((user) => {
        if (user?.roles?.includes(UserRoles.IS_ADMIN)) {
          const queries = selectedIndexes.map((index) => ({
            indexUid: index,
            q: query,
            highlightPreTag: '<u>',
            highlightPostTag: '</u>',
            attributesToHighlight: ['*'],
            limit: 5,
          }));
          return queries;
        } else {
          const queries = selectedIndexes.map((index) => ({
            indexUid: index,
            q: query,
            highlightPreTag: '<u>',
            highlightPostTag: '</u>',
            attributesToHighlight: ['*'],
            limit: 5,
            filter: `ancestors = ${user.sub}`,
          }));
          return queries;
        }
      }),
      switchMap(
        (
          queries: {
            indexUid: string;
            q: string;
            highlightPreTag: string;
            highlightPostTag: string;
            attributesToHighlight: string[];
            limit: number;
            filter?: string;
          }[],
        ) => {
          return from(
            this.client.multiSearch({
              queries,
            }),
          );
        },
      ),
      map(
        (res: MultiSearchResponse<RecordAny>) =>
          new Map(res.results.map((r: any) => [r.indexUid, r.hits.map((h: { _formatted: any }) => h._formatted)])),
      ),
    );
  }
}
